import { z } from 'zod';

import { QuestionType } from '@/domain/impact/impact.entity';
import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';

const envValueDtoSchema = z.object({
  id: z.number(),
  paramId: z.string(),
  projectId: z.number(),
  value: z.string(),
  score: z.number(),
});

export const getImpactAnswersResponsesDtoSchema = z.array(envValueDtoSchema);

const i18nTextDtoSchema = z.object({
  fr: z.string().optional(),
  en: z.string().optional(),
});

const modelParameterDtoSchema = z.object({
  paramId: z.string(),
  topic: z.nativeEnum(EnvTopic),
  section: z.nativeEnum(EnvSection),
  type: z.string().toLowerCase().pipe(z.nativeEnum(QuestionType)),
  title: i18nTextDtoSchema,
  helpText: i18nTextDtoSchema.optional(),
  options: z
    .array(z.object({ optionId: z.string(), title: i18nTextDtoSchema }))
    .optional(),
  fields: z.array(z.object({ title: i18nTextDtoSchema })).optional(),
  dependency: z
    .object({
      questions: z.array(z.string()).optional(),
      rules: z
        .array(
          z.object({
            conditions: z.object({
              $eq: z.union([z.string(), z.number(), z.boolean()]),
            }),
            value: z.boolean(),
          }),
        )
        .optional(),
    })
    .optional(),
});

export const getModelParametersDtoSchema = z.record(modelParameterDtoSchema);

export type ModelParametersDto = z.infer<typeof getModelParametersDtoSchema>;
